export const PERMISSIONS = {
  EVENTADMIN: "EVENTADMIN",
  PLAYERADMIN: "PLAYERADMIN"
} as const;